import URLDATA from "../Config";
import axiosInstance from "./Interceptor";

const getToken = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const token = userData ? userData.access_token : "";
  return token;
};

const getHeader = () => {
  const headers = new Headers();
  const token = getToken();
  headers.append("Authorization", `Bearer ${token}`);
  headers.append("Content-Type", "application/json");
  return headers;
};

export const UploadPostMethod = (Query, Variables) => {
  const headers2 = new Headers();
  const token = getToken();
  headers2.append("Authorization", `Bearer ${token}`);
  return axiosInstance.post(Query, Variables);
};

export const UploadPutMethod = (Query, Variables) => {
  const headers2 = new Headers();
  const token = getToken();
  headers2.append("Authorization", `Bearer ${token}`);
  return axiosInstance.put(Query, Variables);
};

export const UploadPatchMethod = (Query, Variables) => {
  const headers2 = new Headers();
  const token = getToken();
  headers2.append("Authorization", `Bearer ${token}`);
  return axiosInstance.patch(Query, Variables);
};

export const PostMethod = (Query, Variables) => {
  return axiosInstance.post(Query, Variables);
};

export const PutMethod = (Query, Variables) => {
  return axiosInstance.put(Query, Variables);
};
export const PatchMethod = (Query, Variables) => {
  return axiosInstance.patch(Query, Variables);
};

export const getMethod = (Query) => {
  return axiosInstance.get(Query);
};

export const deleteMethod = (Query) => {
  return axiosInstance.delete(Query);
};
